import styles from './Balance.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { roundNumber } from '../../../utils/formatDecimal';
import { getTranslation } from '../../../utils/translation';
import classNames from 'classnames';

export default function Balance({ limit }) {
    return (
        <div className={styles.balance}>
            <i className={classNames('icon-azn', styles.icon)} />
            <span>
                {getTranslation('common.currentLimit')}
                {': '}
                <span className={styles.amount}>{roundNumber(limit, 2)} AZN</span>
            </span>
        </div>
    );
}

Balance.propTypes = {
    limit: PropTypes.number,
};
